import { Button, Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

import Bookmark from '../../components/Bookmark/Bookmark';
import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon';
import SearchForm from '../../components/SearchForm/SearchForm';
import Spinner from '../../components/Spinner/Spinner';
import ProfileCard from '../../components/Cards/ProfileCard'

import useMentorsMenteesList from './useMentorsMenteesList';

import styles from './MentorsMenteesList.module.scss';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import { TabStatus } from './MentorsMenteesList.model';

const MentorsMenteesList = () => {
	const {
		bookmarkUser,
		deleteBookmark,
		state,
		onChangePagination,
		onChangeViewBookmarkedOnly,
		onRefresh,
		onResetFilters,
		onSaveSearchResults,
		onSearchByTerm,
		onSubmitFilters,
		toggleMobileFilters,
	} = useMentorsMenteesList();
	const {
		filterDefaultValues,
		filterFields,
		filterStickyValues,
		pagination,
		showMobileFilters,
		stickyFilters,
		tabStatus,
		users
	} = state;

	const history = useHistory();

	return (
		<div className={`${styles.pageContainer} ${styles.contentAsCards}`}>
			<div className={`${styles.pageSider} ${styles.topBorder}`}>
				<SearchForm
					searchByTermDefaultValue={stickyFilters.name}
					onSearchByTerm={onSearchByTerm}/>
				<FiltersForm
					fields={filterFields}
					defaultValues={filterDefaultValues}
					stickyValues={filterStickyValues}
					onResetFilters={onResetFilters}
					onSearchByTerm={onSearchByTerm}
					onSubmit={(filters) => onSubmitFilters(filters)} />
			</div>

			<div className={styles.pageContent} id="scrollable">
				<div className={styles.mobileTopper}>
					<SearchForm
						searchByTermDefaultValue={stickyFilters.name}
						onSearchByTerm={onSearchByTerm}/>
					<Button type="text" onClick={toggleMobileFilters} icon={<Icon color="black" name="sliders-h" />} />
				</div>
				<div className={styles.header}>
					<h1><FormattedMessage id="mentors.title" values={{b: (...chunks: any) => <b>{chunks}</b>}}/></h1>
					<div className={styles.tabBarExtraContent}>
						<Checkbox className={styles.checkbox} defaultChecked={stickyFilters.bookmarkedOnly} onChange={onChangeViewBookmarkedOnly}><FormattedMessage id="formLabels.viewBookmarked" /></Checkbox>
						<Button size="large" type="default" onClick={onSaveSearchResults}><FormattedMessage id="buttons.saveSearchResults" /></Button>
					</div>
				</div>
				
				<Spinner delay={0} spinning={tabStatus === TabStatus.Loading} />

				<InfiniteScroll
					className={styles.cards}
					dataLength={users.length}
					next={onChangePagination}
					hasMore={users.length === pagination.size}
					loader={<></>}
					scrollableTarget="scrollable"
				>
					{users?.length ? users.map((object, index) => {
							const {
								bookmarkId,
								education,
								id,
								imageId,
								location,
								name,
								researchAreas,
								userType,
								workExperience,
							} = object;
							return <ProfileCard
								data={{
									education,
									imageId,
									location,
									name,
									researchAreas,
									userType,
									workExperience,
								}}
								hoverable={true}
								key={`user${index}`}
								showData={true}
								onClick={() => { history.push(`/members-list/${id}`) }}>
									<Bookmark
										isBookmarked={!!bookmarkId}
										key={bookmarkId}
										onBookmark={bookmarkUser.bind(null, id)}
										onDeleteBookmark={deleteBookmark.bind(null, bookmarkId)}
									/>
							</ProfileCard>;
						})
					: <p className={styles.emptyContent}><FormattedMessage id="emptyContent.noResults"/></p>}
				</InfiniteScroll>
				<ErrorMessage onRefresh={onRefresh} error={tabStatus === TabStatus.Error} showReport={true}/>
			</div>

			{/* Mobile filters */}
			<div className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''}`}></div>
			<div className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''}`}>
				<div className={styles.actions}>
					<Button onClick={toggleMobileFilters} type="link" style={{paddingRight: 0}}>
						<Icon
							color="text"
							height="16px"
							name="times"
							width="16px"
						/>
					</Button>
				</div>
				<FiltersForm
					fields={filterFields}
					defaultValues={filterDefaultValues}
					stickyValues={filterStickyValues}
					onResetFilters={() => onResetFilters(toggleMobileFilters)}
					onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)} />
			</div>
		</div>
	);
};

export default MentorsMenteesList;